<template>
  <b-card
    no-body
    class="mb-0"
  >
    <div class="m-2">
      <div class="content-box">
        <div class="mb-1">
          本岗位招聘人数{{ needNum }}人，初审通过人数{{ firstPassNum }}人，实际在岗人数{{ hiredNum }}人。
        </div>
        <div class="select-box">
          <b-row>
            <b-col cols="12" md="3" class="mb-1">
              <el-select
                v-model="checkStatusVal"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in checkStatusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </b-col>
            <b-col cols="12" md="3" class="mb-1">
              <el-select
                v-model="jobStateValue"
                placeholder="请选择在岗状态"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in jobStateOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </b-col>
            <b-col cols="12" md="6" class="mb-1" align="right">
              <el-button
                type="primary"
                @click="searchIt"
              >筛选</el-button>
            </b-col>
          </b-row>
        </div>
        <div class="table-box">
          <el-table
            :row-class-name="tableRowClassName"
            :data="tableData"
            class="responsive"
          >
            <el-table-responsive-column
              type="index"
              label="序号"
              width="60"
            />
            <el-table-responsive-column
              prop="applicant.realName"
              label="学生姓名"
            />
            <el-table-responsive-column
              prop="applicant.userName"
              label="学号"
            />
            <el-table-responsive-column label="申请日期">
              <template slot-scope="scope">
                <span>{{ scope.row.createDate | moment('YYYY-MM-DD') }}</span>
              </template>
            </el-table-responsive-column>
            <el-table-responsive-column label="申请材料">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="checkIt(scope.row)"
                >查看</el-button>
              </template>
            </el-table-responsive-column>
            <el-table-responsive-column label="面试通知">
              <template slot-scope="scope">
                <div v-if="scope.row.interviewStatus === 'NONE'">
                  <el-button
                    type="text"
                    @click="sendIt(scope.row)"
                  >发送</el-button>
                  <el-button
                    style="color: red"
                    type="text"
                    @click="refuseIt(scope.row)"
                  >拒绝</el-button>
                </div>
                <div v-else-if="scope.row.interviewStatus === 'SEND'">
                  已发送
                </div>
                <div
                  v-else
                  style="color: red"
                >
                  不发送
                </div>
              </template>
            </el-table-responsive-column>
            <el-table-responsive-column label="面试结果">
              <template slot-scope="scope">
                <div v-if="scope.row.interviewStatus === 'NONE' || scope.row.interviewStatus === 'FAIL'">
                  --
                </div>
                <div v-else>
                  <!--<el-button type="text" @click="writeIn(scope.row)" v-if="scope.row.interviewResult === 'NONE'">录入</el-button>-->
                  <span v-if="scope.row.interviewResult === 'PASS'">通过</span>
                  <span
                    v-else-if="scope.row.interviewResult === 'FAIL'"
                    style="color: red;"
                  >不通过</span>
                  <span v-else>--</span>
                </div>
              </template>
            </el-table-responsive-column>
            <el-table-responsive-column
              :show-overflow-tooltip="true"
              label="面试评价"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.interviewStatus !== 'SEND' || scope.row.interviewResult === 'NONE'">--</span>
                <span v-else>{{ scope.row.interviewAssessment }}</span>
              </template>
            </el-table-responsive-column>
            <el-table-responsive-column label="终审结果">
              <template slot-scope="scope">
                <span v-if="scope.row.interviewStatus !== 'SEND' || scope.row.interviewResult !== 'PASS'">--</span>
                <span v-else>{{ jobsStatus(scope.row.checkStatus) }}</span>
              </template>
            </el-table-responsive-column>
            <el-table-responsive-column
              prop="applicationStatus"
              label="上岗状态"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.applicationStatus === 'FIRED'">已解聘</span>
                <span v-if="scope.row.applicationStatus === 'WORKING'">工作中</span>
                <span v-if="scope.row.applicationStatus === 'NONE'">初始</span>
                <span v-if="scope.row.applicationStatus === 'FAIL'">拒绝</span>
              </template>
            </el-table-responsive-column>
          </el-table>
        </div>
        <div class="pagantion-box">
          <el-pagination
            :current-page="currentPage + 1"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="totalSize"
            @current-change="handleCurrentChange"
          />
        </div>
        <div class="dialog-box">
          <applicationMaterial
            ref="applicationMaterial"
            :application-data="applicationData"
            :info-obj="infoObj"
          />
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { applicationService } from '@/api/index'
import { jobsStatus } from '@/tool/utils'
import applicationMaterial from '@/components/ApplicationMaterials.vue'

export default {
  name: 'ShowDetail',
  components: {
    applicationMaterial,
  },
  data() {
    return {
      checkStatusVal: 0,
      // 结果状态：0，不限；1，待提交；2，聘用；3，不聘用 ,
      checkStatusList: [
        { id: 0, name: '不限终审结果状态' },
        { id: 1, name: '待提交' },
        { id: 2, name: '聘用' },
        { id: 3, name: '不聘用' },
      ],
      totalSize: 0,
      currentPage: 0,
      tableData: [],
      applicationData: null,
      needNum: '',
      firstPassNum: null,
      hiredNum: null,
      infoObj: null,
      jobStateValue: '',
      jobStateOptions: [
        {
          value: 0,
          label: '初始',
        },
        {
          value: 1,
          label: '拒绝',
        },
        {
          value: 2,
          label: '工作中',
        },
        {
          value: 3,
          label: '已解聘',
        },
      ],
    }
  },
  mounted() {
    this.initPage()
  },
  methods: {
    jobsStatus,
    initPage() {
      this.needNum = this.$route.query.needNum
      this.queryTable()
    },
    queryTable() {
      this.id = this.$route.query.id
      const params = {
        applicationStatus: this.jobStateValue,
        jobId: this.id,
        checkStatus: this.checkStatusVal,
        page: this.currentPage,
        size: 10,
        type: 1, // 1单位， 2学工
      }
      applicationService()._studentCheckList(params).then(res => {
        if (res.status) {
          this.tableData = res.data.res.content
          this.totalSize = res.data.res.totalElements
          this.hiredNum = res.data.hiredNum
          this.firstPassNum = res.data.firstPassNum
        }
      })
    },
    // 调整表格颜色
    tableRowClassName(row) {
      if (row.row.checkStatus === 2) {
        return 'success-row'
      }
      return ''
    },
    checkIt(row) {
      const params = {
        study: row.study,
        work: row.work,
        economic: row.economic,
        cognition: row.cognition,
        hobbies: row.hobbies,
        items: JSON.parse(row.schedule),
      }
      this.applicationData = params
      this.infoObj = row.applicant
      const bankInfo = {
        bankNoDefault: row.bankNoDefault,
        bankNo: row.bankNo,
        bankName: row.bankName,
        defaultBankNo: row.defaultBankNo,
      }
      Object.assign(this.infoObj, bankInfo, { subsidyList: row.subsidyList }, { salaryList: row.salaryList })
      this.$refs.applicationMaterial.dialogVisible = true
    },
    handleCurrentChange(val) {
      this.currentPage = val - 1
      this.queryTable()
    },
    searchIt() {
      this.currentPage = 0
      this.queryTable()
    },
  },
}
</script>

<style scoped>
</style>
